export default "<!--<app-prelogin-header></app-prelogin-header>-->\r\n<!--<router-outlet></router-outlet>-->\r\n<app-auth-layout></app-auth-layout>\r\n"